<template>
  <cms-modal unique="view-vessel-management" title="View Management History" size="lg">
    <form @submit.prevent="confirmUpdateVesselManagement">

      <div class="form-group form-row mb-1" :class="{'has-error': vesselManagementErrors.management_from_id}">
        <label for="management-from-id" class="col col-sm-3 col-form-label font-weight-bolder">
          From:
        </label>
        <div class="col col-sm-8 offset-1 col-form-label p-0">


          <select id="management-from-id" class="form-control form-control-xs"
                  v-model="vesselManagement.management_from_id"
                  @change="showOtherFrom"
                  :disabled="!editable"
          >
            <option :value="null">------</option>
            <option v-for="management in managements" :key="management.id"
                    :value="management.id">
              {{ management.name }}
            </option>
            <option value="">--- Other ---</option>
          </select>

          <span class="help-block" v-if="vesselManagementErrors.management_from_id !== ''">
            <small><strong>{{ vesselManagementErrors.management_from_id }}</strong></small>
          </span>
        </div>
      </div>


      <div class="form-group form-row mb-1" v-if="otherFrom">
        <label for="other-management-from2" class="col col-sm-3 col-form-label font-weight-bolder">
          Other:
        </label>
        <div class="col col-sm-8 offset-1 col-form-label p-0">
          <input type="text" id="other-management-from2"
                 class="form-control form-control-xs"
                 placeholder="Specify Management Name for this record"
                 v-model="vesselManagement.other_management_from"
                 :readonly="!editable"
          >
        </div>
      </div>


      <!--      Management To-->
      <div class="form-group form-row mb-1" :class="{'has-error': vesselManagementErrors.management_to_id}">
        <label for="management-to" class="col col-sm-3 col-form-label font-weight-bolder">
          To:
        </label>
        <div class="col col-sm-8 offset-1 col-form-label p-0">

          <select id="management-to" class="form-control form-control-xs"
                  v-model="vesselManagement.management_to_id"
                  :disabled="!editable"
                  @change="showOtherTo"
          >
            <option :value="null">------</option>
            <option v-for="management in managements" :key="management.id" :value="management.id">
              {{ management.name }}
            </option>
            <option value="">--- Other ---</option>
          </select>
          <span class="help-block" v-if="vesselManagementErrors.management_to_id !== ''">
                      <small><strong>{{ vesselManagementErrors.management_to_id }}</strong></small>
                    </span>
        </div>
      </div>

      <div class="form-group form-row mb-1" v-if="otherTo">
        <label for="other-management-to" class="col col-sm-3 col-form-label font-weight-bolder">
          Other:
        </label>
        <div class="col col-sm-8 offset-1 col-form-label p-0">
          <input type="text" id="other-management-to"
                 class="form-control form-control-xs"
                 placeholder="Specify Management Name for this record"
                 v-model="vesselManagement.other_management_to"
                 :readonly="!editable"
          >
        </div>
      </div>

      <div class="form-group form-row mb-1" :class="{'has-error': vesselManagementErrors.date_transferred}">
        <label for="date-from" class="col col-sm-3 col-form-label font-weight-bolder">
          Date Transferred:
        </label>
        <div class="col col-sm-8 offset-1 col-form-label p-0">
          <input type="date" id="date-from" v-if="editable"
                 class="form-control form-control-xs"
                 v-model="vesselManagement.date_transferred"
          >
          <input type="text" readonly v-else
                 class="form-control form-control-xs"
                 placeholder="Start Date Not Specified"
                 :value="vesselManagement.date_transferred | moment('D MMMM YYYY')"
          >
          <span class="help-block" v-if="vesselManagementErrors.date_transferred !== ''">
                      <small><strong>{{ vesselManagementErrors.date_transferred }}</strong></small>
                    </span>
        </div>
      </div>

      <hr />
      <div class="float-right">
        <button type="submit" class="btn btn-warning btn-sm btn-xs mr-3 font-weight-bolder"
                v-if="isSystemAdmin || isPrincipal || isPrincipalStaff || isDesignatedPrincipal">
          <i class="fas fa-edit"></i>
          {{ editable ? 'Update' : 'Edit' }}
        </button>
        <button class="btn btn-danger btn-sm btn-xs font-weight-bolder"
                v-if="editable"
                @click="cancelEdit"
        >
          <span class="fas fa-ban"></span>
        </button>
      </div>

    </form>
  </cms-modal>
</template>

<script>
import {vueAppMixin} from '@/mixins/vueAppMixin';
import {formMixin} from '@/mixins/formMixin';
import {gateMixin} from '@/mixins/gateMixin';
import CmsModal from '@/components/elements/CmsModal';
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'EditManagementHistory',

  mixins: [vueAppMixin, formMixin, gateMixin],

  components: {CmsModal},

  data() {
    return {
      vesselManagement: {},
      vesselManagementErrors: {},
      isVisibleManagementFrom: true,
      editable: false,
      editFields: [
        'id', 'management_from_id', 'other_management_from',
        'management_to_id', 'other_management_to', 'date_transferred',
      ],

      otherFrom: false,
      otherTo: false,

    };
  },

  props: {
    viewVesselManagement: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  methods: {
    ...mapActions([
      'updateVesselManagement',
    ]),

    async confirmUpdateVesselManagement() {
      if (this.editable) {
        if (await this.confirmUpdate()) {
          let params = {};
          this.editFields.forEach(key => {
            let value = this.vesselManagement[key] ? this.vesselManagement[key] : '';
            if (value === '0000-00-00') value = '';
            params[key] = value;

            // console.log(key , value, 'keyvalll') // key ,value
          });
          let updatedVesselManagement = await this.updateVesselManagement(params);
          if (updatedVesselManagement) {
            if (updatedVesselManagement.errors) {
              this.vesselManagementErrors = updatedVesselManagement.errors;
            } else {
              this.successAlert('Vessel Management History Record Successfully Updated', 'UPDATE');
              document.getElementById('close-view-vessel-management').click();
              this.vesselManagement = Object.assign({}, updatedVesselManagement);
              // console.log(params, 'params from rank list update');
              this.vesselManagementErrors = {};
            }
          }
        }
      } else {
        this.editable = true;
      }
    },

    cancelEdit() {
      this.editable = false;
      // this.otherFrom = false;
      // this.otherTo = false;
      this.vesselManagement = Object.assign({}, this.viewVesselManagement);
    },

    clearManagementTo() {
      this.vesselManagement.management_to_id = null;
    },

    showOtherFrom: function(e) {
      this.otherFrom = e.target.value === '';
      // console.log(this.otherFrom, 'otherFrom');

      // if (e.target.value === 'otherFrom') {
      //   this.otherFrom = true;
      // }else{
      //   this.otherFrom = false;
      // }
    },

    showOtherTo: function(e) {
      this.otherTo = e.target.value === '';
      // console.log(this.otherTo, 'otherTo');
    },

  },

  computed: {
    ...mapGetters([
      'managements',
      'vesselInfo',
    ]),
  },

  watch: {
    'viewVesselManagement'() {
      this.vesselManagement = Object.assign({}, this.viewVesselManagement);
      this.editable = false;
    },

    'vesselManagement.other_management_from'() {
      if (this.vesselManagement.other_management_from) {
        this.otherFrom = true;
        this.vesselManagement.management_from_id = null;
      } else {
        this.otherFrom = false;
      }
    },

    'vesselManagement.management_from_id'() {
      if (this.vesselManagement.management_from_id) {
        this.vesselManagement.other_management_from = null;
      }
    },

    'vesselManagement.other_management_to'() {
      if (this.vesselManagement.other_management_to) {
        this.otherTo = true;
        this.vesselManagement.management_to_id = null;
      } else {
        this.otherTo = false;
      }
    },

    'vesselManagement.management_to_id'() {
      if (this.vesselManagement.management_to_id) {
        this.vesselManagement.other_management_to = null;
      }
    },
  },

};
</script>

<style scoped>

</style>
